var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRemoveCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#fff",
    id: "Icons",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2,26c-0.1-0.6-0.2-1.3-0.2-2H7.6C7.3,24,7,23.7,7,23.4c0-0.3,0.2-0.6,0.5-0.6l6.8-1.1c1-4.4,5-7.7,9.7-7.7  c1,0,1.9,0.1,2.8,0.4L28,8.2c0.1-0.5-0.3-1.1-0.8-1.2c-0.5-0.1-1.1,0.3-1.2,0.8L25.8,9H6.6l0-0.1c0.6-1.3,0.6-2.8-0.2-4  C5.7,3.7,4.4,3,3,3H1C0.4,3,0,3.4,0,4s0.4,1,1,1h2c0.7,0,1.4,0.4,1.8,1c0.4,0.6,0.4,1.4,0.1,2L4.1,9.6c0,0,0,0,0,0  c0,0.1,0,0.1-0.1,0.2C4,9.8,4,9.9,4,10c0,0,0,0,0,0c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2l3.8,10.3l-0.6,0.1C5.9,21,5,22.1,5,23.4  c0,1,0.5,1.8,1.3,2.3C6.1,26.1,6,26.5,6,27c0,1.7,1.3,3,3,3s3-1.3,3-3c0-0.4-0.1-0.7-0.2-1H14.2z M9,28c-0.6,0-1-0.4-1-1s0.4-1,1-1  s1,0.4,1,1S9.6,28,9,28z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24,16c-4.4,0-8,3.6-8,8s3.6,8,8,8s8-3.6,8-8S28.4,16,24,16z M27,25h-6c-0.6,0-1-0.4-1-1s0.4-1,1-1h6c0.6,0,1,0.4,1,1  S27.6,25,27,25z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveCart);
export default __webpack_public_path__ + "static/media/remove_cart.2b397cd3cefdf4bdc4dec09aef9851ee.svg";
export { ForwardRef as ReactComponent };